import React, { useState } from 'react'

export const ConsultationForm = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

  return (
    <form>
        <div className="slope-contact-form">
            <div className="fields-wrapper">
                <div className="input-contact" style={{ width: '100%' }}>
                    <span className="name-field" style={{ width: '100%' }}>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                            name="name-field"
                            placeholder="Your name *"
                            style={{ width: '100%' }}
                        />
                    </span>

                    <span className="email-field" style={{ width: '100%' }}>
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            name="email-field"
                            size="40"
                            placeholder="Email address *"
                            style={{ width: '100%' }}
                        />
                    </span>

                    <span className="number-field" style={{ width: '100%' }}>
                        <input
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            type="tel"
                            name="number-field" 
                            placeholder="Phone"
                            style={{ width: '100%' }}
                        />
                    </span>

                    <span className="subject-field" style={{ width: '100%' }}>
                        <input
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            type="text"
                            name="subject-field"
                            placeholder="Subject *"
                            style={{ width: '100%' }}
                        />
                    </span>
                </div>
                <div className="textarea-contact" style={{ width: '100%' }}>
                    <span className="message-field" style={{ width: '100%' }}>
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            name="message-field"
                            placeholder="Please describe how we can help you *"
                            style={{ width: '100%' }}
                        ></textarea>
                    </span>
                </div>
            </div>
            <div className="submit-contact">
                <input type="submit" value="Submit" />
            </div>
        </div>
    </form>
  )
}
